import React from 'react';
import { ContentBlock } from '../ContentBlock';
import { Scheme } from '../ContentBlock/contentBlockUtils';

import styles from './index.module.scss';

export const Newsletter: React.FC = () => {
    return (
        <ContentBlock title="Melde dich zum Newsletter an!" scheme={Scheme.grayLimeGreen} contentClassNames={styles.container}>
            <iframe
                title="newsletter"
                src="https://2d7813cf.sibforms.com/serve/MUIFAK_1QwOSCrYgIjSJTmckEJ7kXs5JEJPm_2UDiKjoxs_VSsdO2BHU2b5Fk5EeeV8wBVjwPg4IVuDKHJybwCeccV0U2vihg5DWar4766Sqa9xVuK3Tuo3HEK2--h-0pQLa9AZSXr-dnWps6zcilkdzBVVx61YTFIkabujOlI00dbdgxhvILLibH7GT9oGzGAQupeXnLXjxTykU"
                frameBorder="0"
                scrolling="auto"
                allowFullScreen
                style={{
                    display: 'block',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    width: '100%',
                    height: '650px',
                    marginTop: '-32px',
                }}
            />
        </ContentBlock>
    );
};
